var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconThreeDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 4,
    viewBox: "0 0 14 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66671 1.99998C3.66671 2.92045 2.92052 3.66665 2.00004 3.66665C1.07957 3.66665 0.333374 2.92045 0.333374 1.99998C0.333374 1.07951 1.07957 0.333313 2.00004 0.333313C2.92052 0.333313 3.66671 1.07951 3.66671 1.99998ZM8.66671 1.99998C8.66671 2.92045 7.92052 3.66665 7.00004 3.66665C6.07957 3.66665 5.33337 2.92045 5.33337 1.99998C5.33337 1.07951 6.07957 0.333313 7.00004 0.333313C7.92052 0.333313 8.66671 1.07951 8.66671 1.99998ZM12 3.66665C12.9205 3.66665 13.6667 2.92045 13.6667 1.99998C13.6667 1.07951 12.9205 0.333313 12 0.333313C11.0796 0.333313 10.3334 1.07951 10.3334 1.99998C10.3334 2.92045 11.0796 3.66665 12 3.66665Z",
    fill: "#222729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThreeDots);
export default __webpack_public_path__ + "static/media/icon-three-dots.189eca6a3eca4a9472212787df38c7bf.svg";
export { ForwardRef as ReactComponent };